import React, { useRef } from "react";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";

const TextEditor = (props) => {
    const editorRef = useRef();

    return (
        <SunEditor
            lang="en"
            height="200"
            ref={editorRef}
            {...props}
        />
    );
};

export default TextEditor;
